import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=31965a44&scoped=true&"
import script from "./NavList.vue?vue&type=script&lang=js&"
export * from "./NavList.vue?vue&type=script&lang=js&"
import style0 from "./NavList.vue?vue&type=style&index=0&id=31965a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31965a44",
  null
  
)

export default component.exports